import {
  hasAutomationConfigurationPage,
  WorkflowEditPageStep,
} from "@/pages/workflows/edit/pages/workflow-edit-pages.tsx";
import { ApiWorkflow, ApiWorkflowVersion } from "@/types/workflows/workflow.types.ts";
import { LinkTo, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export const WorkflowEditSidebar = ({
  step,
  workflow,
  workflowVersion,
}: {
  step: WorkflowEditPageStep;
  workflow?: ApiWorkflow;
  workflowVersion?: ApiWorkflowVersion;
}) => {
  const { t } = useTranslation();
  const stepTitleMap = {
    [WorkflowEditPageStep.details]: t("common:details"),
    [WorkflowEditPageStep.visibility]: t("common:visibility"),
    [WorkflowEditPageStep.automation]: t("common:automation"),
    [WorkflowEditPageStep.automation_setup]: t("workflow:automation_setup"),
    [WorkflowEditPageStep.flow]: t("workflow:actions"),
    [WorkflowEditPageStep.final]: "",
  };
  const showAutomationSetup =
    workflow &&
    hasAutomationConfigurationPage(
      workflow.trigger_type,
      workflowVersion?.trigger_schedule_rule?.entity_type
    );
  const steps = [
    WorkflowEditPageStep.details,
    WorkflowEditPageStep.visibility,
    WorkflowEditPageStep.automation,
    ...(showAutomationSetup ? [WorkflowEditPageStep.automation_setup] : []),
    WorkflowEditPageStep.flow,
  ];

  return (
    <Stack className={"px-6"} gap={"md"}>
      {steps.map((item) => {
        const className = step === item ? "text-default" : "text-secondary";

        if (!workflow) {
          return (
            <Text key={item} className={className}>
              {stepTitleMap[item]}
            </Text>
          );
        }

        return (
          <LinkTo
            key={item}
            to={`/workflows/${workflow.id}/setup/${item}`}
            variant={"plain"}
            className={className}
          >
            <Text>{stepTitleMap[item]}</Text>
          </LinkTo>
        );
      })}
    </Stack>
  );
};
